import { Injectable } from '@angular/core';
import localeRu from '@angular/common/locales/ru';
import localeEs from '@angular/common/locales/es';
import localeArAe from '@angular/common/locales/ar-AE';
import { registerLocaleData } from '@angular/common';

import { ResourcesProvider, EzLocaleHelper } from '@ezuiaws/ez.ui.packages/ez-localization';

import { ResourceKeys } from './resource-keys';
import localeEnUsUsd from './locales/en-US-USD';
import localeEnGbGbp from './locales/en-GB-GBP';
import localeEnCaCad from './locales/en-CA-CAD';
import localeEnAuAud from './locales/en-AU-AUD';
import localeArAeAed from './locales/ar-AE-AED';
import localeEnIeEur from './locales/en-IE-EUR';
import localeEnUsCad from './locales/en-US-CAD';
import localeEnMuMur from './locales/en-MU-MUR';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService {
  static rks: Partial<ResourceKeys>;

  init(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      void LocalizationService.loadResources()
        .then(() => {
          LocalizationService.rks = ResourcesProvider.rks;
          registerLocaleData(localeEnUsUsd, 'en-US-USD');
          registerLocaleData(localeEnGbGbp, 'en-GB-GBP');
          registerLocaleData(localeEnCaCad, 'en-CA-CAD');
          registerLocaleData(localeEnAuAud, 'en-AU-AUD');
          registerLocaleData(localeArAeAed, 'ar-AE-AED');
          registerLocaleData(localeEnIeEur, 'en-IE-EUR');
          registerLocaleData(localeEnUsCad, 'en-US-CAD');
          registerLocaleData(localeEnMuMur, 'en-MU-MUR');
          registerLocaleData(localeArAe, 'ar-AE');
          registerLocaleData(localeRu, 'ru');
          registerLocaleData(localeEs, 'es');
        })
        .then(() => resolve(true));
    });
  }

  static loadResources(): Promise<boolean> {
    return new Promise((resolve) => {
      const userLanguageLocale: string = EzLocaleHelper.languageLocale;
      LocalizationService.importResources(userLanguageLocale).then(res => {

        LocalizationService.rks = Object.assign({}, res.resources);
        ResourcesProvider.rks = Object.assign({}, res.resources);

        resolve(true);

      }).catch(LocalizationService.errorHandler());
    });
  }

  private static importResources(locale: string): Promise<any> {
    switch (locale.toLowerCase()) {
      case 'ar-ae':
        return import(`src/assets/localizations/resources.ar-ae`);
      case 'en-gb':
        return import(`src/assets/localizations/resources.en-gb`);
      case 'en-ca':
        return import(`src/assets/localizations/resources.en-ca`);
      case 'en-us':
      default:
        return import(`src/assets/localizations/resources.en-us`);
    }
  }

  private static errorHandler() {
    //if there is still an error with the default locale/culture, log the error
    return (localizationError: Error) => console.error(`localizationError ${localizationError.message}`);
  }
}
